export const REDUX_STORE_HOME = 'add_zoom_source'
